/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'message-items';
const componentName = 'alert-syslog-server';
const prefix = `${moduleName}.${componentName}`;

export const alertSyslogServerBreadcrumbTitle = `${prefix}.alertSyslogServerBreadcrumbTitle`;

export const ENGLISH = {
    [alertSyslogServerBreadcrumbTitle]: 'Syslog Server',
};
